import MockApiService from "./MockApiService";
import V3ApiService from "./V3ApiService";
import ApiService from "./ApiService";
import AnonymousV3ApiService from "./AnonymousV3ApiService";

export default function createApiService(
  dbToken: string,
  jwt: string,
  apiVersion: string = 'mock',
  apiUrl: string = '',
  appContext: string,
  routeChangeFunc: any = undefined,
  login = false,

): ApiService {
  if(appContext !== "production") {
    console.log('createApiService',dbToken, '-', jwt, '-', apiUrl, routeChangeFunc);
  }

  if (apiVersion === "mock") {
    return new MockApiService(dbToken, jwt);
  } else {
    if(jwt || login)
      return new V3ApiService(dbToken, jwt, apiUrl, routeChangeFunc);
    else
      return new AnonymousV3ApiService(dbToken, jwt, apiUrl, routeChangeFunc);
  }
}
